import React, { Component } from "react";
import "component/common/Tabs/styles.scss";

class Tabs extends Component {
  getIcon(rel) {
    if (!this.props.getIcon) return null;
    return this.props.getIcon(rel);
  }

  renderIndexBasedTabs() {
    const { items, activeTabIndex, setActiveTabIndex, setLabel, minimize, title, getTabTestId } = this.props;
    
    return (
      <div className={`tabs ${minimize ? "minimize" : ""}`}>
        {title && (
          <div className="title">
            {!items && <span className="dummy">loading</span>}
          </div>
        )}

        <div className="nav-container">
          <ul className="nav nav-pills nav-fill">
            {items &&
              items.map((item, key) => {
                return (
                  <li
                    className="nav-item"
                    key={key}
                    data-testid={getTabTestId ? getTabTestId(item) : undefined}
                    onClick={() => {
                      setActiveTabIndex(key);
                    }}
                  >
                    <span
                      className={`nav-link ${
                        !activeTabIndex && key === 0 ? "active" : ""
                      } ${
                        activeTabIndex &&
                        Number(activeTabIndex) === key
                          ? "active"
                          : ""
                      }`}
                    >
                      {!setLabel && item.get("name")}
                      {setLabel && setLabel(item)}
                    </span>
                  </li>
                );
              })}
            {!items &&
              [...Array(2)].map((item, key) => {
                return (
                  <li
                    className="nav-item"
                    key={key}
                  >
                    <span
                      className={`nav-link ${
                        !activeTabIndex && key === 0 ? "active" : ""
                      } ${
                        activeTabIndex &&
                        Number(activeTabIndex) === key
                          ? "active"
                          : ""
                      }`}
                    >
                      <span className="dummy">loading</span>
                    </span>
                  </li>
                );
              })}
          </ul>
        </div>
      </div>
    );
  }

  renderRelBasedTabs() {
    const { tabs, selectedTab, isLoading, onTabSelect, minimize } = this.props;
    
    return (
      <div className={`tabs equal-width-tabs ${minimize ? "minimize" : ""}`}>
        <div className="nav-container">
          <ul className="nav nav-pills nav-fill">
            {tabs && tabs.size > 0 ? (
              tabs.entrySeq().map(([key, tab]) => {
                const isSelected = tab.get("rel") === selectedTab;
                const Icon = this.getIcon(tab.get("rel"));
                
                return (
                  <li
                    data-testid={`${tab.get("name").toLowerCase()}-tab`}
                    className="nav-item"
                    key={key}
                    onClick={() => !isLoading && onTabSelect(tab.get("rel"))}
                  >
                    <span
                      className={`nav-link ${isSelected ? "active" : ""} ${isLoading ? "disabled" : ""}`}
                    >
                      {Icon && (
                        <i className="nav-icon">
                          <Icon />
                        </i>
                      )}
                      {tab.get("name")}
                    </span>
                  </li>
                );
              })
            ) : (
              [...Array(4)].map((_, key) => {
                return (
                  <li className="nav-item" key={key}>
                    <span className="nav-link disabled">
                      <span className="dummy">loading</span>
                    </span>
                  </li>
                );
              })
            )}
          </ul>
        </div>
      </div>
    );
  }

  render() {
    if (this.props.mode === "rel") {
      return this.renderRelBasedTabs();
    } else {
      return this.renderIndexBasedTabs();
    }
  }
}

export default Tabs;